import React from 'react'
import spinner1 from '../assets/images/honeyguide_spinner_1.webp'
import spinner2 from '../assets/images/honeyguide_spinner_2.webp'
import spinner3 from '../assets/images/honeyguide_spinner_3.webp'

const SPINNERS = [spinner1, spinner2, spinner3]

interface SpinnerProps {
    className?: string
}

const Spinner: React.FC<SpinnerProps> = ({ className = '' }) => {
    // One variant per mount; re-renders must not restart the animation
    const [src] = React.useState(() => SPINNERS[Math.floor(Math.random() * SPINNERS.length)])
    return (
        <img
            src={src}
            alt="Loading..."
            className={`h-48 w-48 ${className}`}
        />
    )
}

export default Spinner
